import * as types from "./actionTypes";

export const fetchPublicProfile = (uid) => {
	return { type: types.PUBLIC_PROFILE_FETCH_PROFILE, payload: uid };
};

export function reFetchPublicProfile(uid) {
	return { type: types.PUBLIC_PROFILE_REFETCH_PROFILE, payload: uid };
}
